package aexorsa

import react.FC
import react.Key
import react.dom.aria.AriaRole
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.footer
import react.dom.html.ReactHTML.header
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.li
import react.dom.html.ReactHTML.ul
import react.dom.html.ReactHTML.main
import react.dom.html.ReactHTML.nav
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.small
import react.dom.html.ReactHTML.span
import react.dom.html.ReactHTML.section
import web.cssom.ClassName

val LandingPage = FC {
    div {
        className = ClassName("landing")

        div {
            className = ClassName("logo-background")
            ariaHidden = true
        }

        header {
            className = ClassName("site-header")

            div {
                className = ClassName("header-brand")

                img {
                    className = ClassName("header-logo")
                    src = "/images/aexorsa-logo-grey.svg"
                    alt = ""
                    draggable = false
                    width = 27.0
                    height = 72.0
                }

                span {
                    className = ClassName("header-wordmark")
                    +"Aexorsa"
                }
            }
        }

        main {
            className = ClassName("page-content home-content")

            section {
                className = ClassName("hero")

                h1 {
                    className = ClassName("hero-title")
                    +"A new beginning for a new era."
                }

                div {
                    className = ClassName("hero-keywords")
                    role = AriaRole.region
                    ariaLabel = "What we are building"
                    tabIndex = 0

                    div {
                        className = ClassName("keyword-track")

                        repeat(2) { copy ->
                            ul {
                                className = ClassName("keyword-list")
                                key = Key("keywords-$copy")
                                ariaHidden = copy == 1

                                for (keyword in listOf("wearable", "intelligent", "personal", "open-source", "independent", "beautiful")) {
                                    li {
                                        key = Key(keyword)
                                        +keyword
                                    }
                                }
                            }
                        }
                    }
                }

                p {
                    className = ClassName("hero-intro")
                    +"We envision a personal, open-source wearable for the next era of technology. "
                    +"Aexorsa draws on the Latin exorsa and orsus, words rooted in the act of beginning."
                }
            }

            SignupForm()
        }

        footer {
            className = ClassName("site-footer")

            small {
                +"© 2026 Aexorsa"
            }

            nav {
                className = ClassName("footer-links")
                ariaLabel = "Footer"

                a {
                    href = "/contact/"
                    +"Contact"
                }

                a {
                    href = "/privacy/"
                    +"Privacy"
                }

                a {
                    href = "/terms/"
                    +"Terms"
                }
            }
        }
    }
}
